
import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";
import backgroundImage from "assets/images/bg-profile.jpg";
import { useSelector } from "react-redux";
import MDButton from "components/MDButton";
import EditModal from "../EditModal";
import profileDefault from "assets/images/Profile-default.jpg";
import { baseUrl } from "services/axiosInstance";
import ChangePass from "../ChangePass";

function Header({ children }) {
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const { adminData } = useSelector((state) => state.adminData)
  const [isEditUserDialogOpen, setIsEditUserDialogOpen] = useState(false);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [changePassOpen, setChangePassOpen] = useState(false);

  const handleEditUserClick = () => {
    setIsEditUserDialogOpen(true);
  };

  const handleClickOpen = () => {
    setChangePassOpen(true);

  };
  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);


  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            ` url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        sx={{
          position: "relative",
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar
              src={
                Array.isArray(adminData?.userProfiles) && adminData.userProfiles.length > 0
                  ? adminData.userProfiles[adminData.userProfiles.length - 1].image
                  : profileDefault
              }
              alt="profile-image"
              size="xl"
              shadow="sm"
            />          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {adminData?.name}
              </MDTypography>
              <MDTypography variant="button" color="text" fontWeight="regular">
                Admin
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginRight: "40px",
                }}
              >
                <MDButton
                  variant="gradient" color="light"
                  onClick={handleEditUserClick}
                  size="small"
                >
                  <MDTypography
                    style={{ fontSize: "13.5px", fontWeight: "bold" }}
                    color="white"
                  >
                    Edit Profile
                  </MDTypography>
                </MDButton>
                <MDBox ml={2}>
                  <MDButton
                    variant="gradient" color="light"
                    size="small"
                    onClick={handleClickOpen}
                  >
                    <MDTypography
                      style={{ fontSize: "13.5px", fontWeight: "bold" }}
                      color="white"
                    >
                      Change Password
                    </MDTypography>
                  </MDButton>
                </MDBox>
              </div>
              <EditModal {...{ isEditUserDialogOpen, setIsEditUserDialogOpen }} />
              <ChangePass {...{ changePassOpen, setChangePassOpen }} />
            </AppBar>
          </Grid>
        </Grid>
        {children}
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
